import DataCards from '../../api/data_cards';
const dataCards = new DataCards();

const dataCardsModule = {
    namespaced: true,
    state: {
        loading: false,
        dataCards: [],
        totalDataCards: 0,
        groupMembers: [],
    },
    getters: {
        dataCards: (state) => state.dataCards,
        totalDataCards: (state) => state.totalDataCards,
        groupMembers: (state) => state.groupMembers,
        loading: (state) => state.loading,
    },
    mutations: {
        SET_LOADING: (state, loading) => {
            state.loading = loading;
        },
        SET_DATA_CARDS: (state, data) => {
            state.dataCards = data;
        },
        SET_TOTAL_DATA_CARDS: (state, count) => {
            state.totalDataCards = count;
        },
        SET_GROUP_MEMBERS: (state, data) => {
            state.groupMembers = data;
        },
    },
    actions: {
        GetDataCards({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.list(payload.query).then(response => {
                    if (response) {
                        const items = response.groupCards || [];
                        let incomingCount = response.total || response.count || 0;
                        const offset = payload.query.offset || 0;

                        // Heuristic to prevent incorrect total from API triggering pagination reset
                        if (offset > 0 && items.length > 0 && incomingCount < (offset + items.length)) {
                            incomingCount = state.totalDataCards;
                        }

                        commit('SET_DATA_CARDS', items);
                        commit('SET_TOTAL_DATA_CARDS', incomingCount);
                    }

                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        GetGroupMembers({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.show(id).then(response => {
                    if (response) {
                        // Using response.data.members as assumed based on standard 'show' resource containing members
                        commit('SET_GROUP_MEMBERS', (response.groupCard && response.groupCard.usersGroupCards) || []);
                    }
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        UpdateGroup({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.update(payload.id, payload.data).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        RemoveGroupMember({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.removeMember(payload.id, payload.userId).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        CreateDataCard({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.store(payload).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
        DeleteDataCard({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true);
                dataCards.delete(id).then(response => {
                    commit('SET_LOADING', false);
                    resolve(response);
                }).catch(error => {
                    commit('SET_LOADING', false);
                    reject(error);
                });
            });
        },
    }
};

export default dataCardsModule;
